<template>
  <div class="text-xs-center">
    <v-pagination v-show="pagination.totalPages > 1" :length="pagination.totalPages" v-model="pagination.currentPage"/>
  </div>
</template>

<script>

export default {
  props: {
    pagination: Object
  },
  watch: {
    'pagination.currentPage' () {
      this.$emit('currentPageChanged')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/fragments/Pagination.vue